"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedCountries = void 0;
const constants_1 = require("../constants");
const SUPPORTED_COUNTRIES_MAP = __importStar(require("../constants/generated/supported-countries.json"));
const getSupportedCountries = (options) => {
    var _a, _b, _c, _d, _e, _f;
    const brands = ((_a = options === null || options === void 0 ? void 0 : options.brands) !== null && _a !== void 0 ? _a : constants_1.ALL_BRANDS).map((x) => x.toLowerCase());
    const awsRegions = ((_b = options === null || options === void 0 ? void 0 : options.awsRegions) !== null && _b !== void 0 ? _b : constants_1.ALL_AWS_REGIONS).map((x) => x.toLowerCase());
    const stages = ((_c = options === null || options === void 0 ? void 0 : options.stages) !== null && _c !== void 0 ? _c : constants_1.ALL_STAGES).map((x) => x.toLowerCase());
    let supportedRegions = [];
    for (const brand of brands) {
        for (const awsRegion of awsRegions) {
            for (const stage of stages) {
                supportedRegions = [
                    ...supportedRegions,
                    ...((_f = (_e = (_d = SUPPORTED_COUNTRIES_MAP[brand]) === null || _d === void 0 ? void 0 : _d[awsRegion]) === null || _e === void 0 ? void 0 : _e[stage]) !== null && _f !== void 0 ? _f : []),
                ];
            }
        }
    }
    return supportedRegions;
};
exports.getSupportedCountries = getSupportedCountries;
